export const en = {
    "k_5686ea01": "Webhook",
    "k_d63dd714": "Loading application...",
    "k_96322eac": "Promise AI pages are temporarily not supported as embedded page slices",
    "k_2f890239": "[xy-client][useDepLoader] dependency loading failed",
    "k_f98a3b9e": "The current page is developed in low code and does not support this mode"
};
